import moment from 'moment';

export default (status, subStatus, EventReport, startDate) => {
    if (status === 'Incomplete') {
        return { status: 'Event Creation', subStatus: 'Incomplete' };
    } else if (status === 'Unapproved') {
        return { status: 'Event Review', subStatus };
    } else if (status === 'Approved' && !!EventReport) {
        if (EventReport.status === 'Pending') {
            return {
                status: 'After Action Pending',
                subStatus: EventReport.subStatus
            };
        } else if (EventReport.status === 'Incomplete') {
            if (moment(startDate) > moment()) {
                return {
                    status: 'After Action Pending',
                    subStatus: EventReport.subStatus
                };
            } else {
                return {
                    status: 'After Action Incomplete',
                    subStatus: 'Incomplete'
                };
            }
        } else if (EventReport.status === 'Unapproved') {
            return {
                status: 'After Action Review',
                subStatus: EventReport.subStatus
            };
        } else if (EventReport.status === 'Approved') {
            return { status: 'Event/After Action Closed', subStatus: 'N/A' };
        } else if (EventReport.status === 'Deleted') {
            return { status: 'After Action Deleted', subStatus: 'N/A' };
        } else {
            return { status: '', subStatus };
        }
    } else if (status === 'Rejected') {
        return { status: 'Rejected', subStatus: subStatus };
    } else {
        return { status: '', subStatus };
    }
};



// WEBPACK FOOTER //
// ./src/helpers/status-substatus.js